
export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-primary via-[#1E4D7B] to-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#4A90C2] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#1E4D7B] rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 font-serif">
          準備開始裝修了嗎？
        </h2>
        <p className="text-xl text-white/90 mb-12 leading-relaxed">
          讓我們一起打造您夢想中的家<br />
          專業團隊隨時為您服務
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://lin.ee/JAWndnI"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-10 py-5 bg-white text-primary rounded-full text-lg font-bold hover:bg-warm-100 transition-all shadow-xl hover:shadow-2xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-message-3-fill text-2xl"></i>
            加入LINE立即諮詢
          </a>
          <a
            href="https://go.hotcake.app/g/VB3HEP"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-10 py-5 bg-transparent text-white rounded-full text-lg font-bold border-2 border-white hover:bg-white hover:text-primary transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-fill text-2xl"></i>
            預約到府評估
          </a>
        </div>

        <div className="mt-16 pt-12 border-t border-white/20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-white mb-2">專業保固</h4>
              <p className="text-sm text-white/80">完整的施工保固服務</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-price-tag-3-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-white mb-2">透明報價</h4>
              <p className="text-sm text-white/80">清楚明確的費用說明</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-white mb-2">貼心服務</h4>
              <p className="text-sm text-white/80">全程專人服務與溝通</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
